function t(t){return t&&"object"==typeof t&&Object.prototype.hasOwnProperty.call(t,"current")}export{t as isRefObject};
